import { desserts, lifestyle } from "./images";

export const CHECKOUT_URL = "https://pay.hotmart.com/B108024148I?checkoutMode=10";

export const PRICE_TODAY = "15.90";
export const FUTURE_PRICE = "47";
export const TOTAL_VALUE = "305.00";

export const mainProduct = {
  title: "Ebook Principal: Pack Dulce Saludable",
  subtitle: "+100 Recetas Gourmet",
  value: 97,
  recipes: [
    { name: "Recetario Postres Variados", detail: "Tortas, brownies y clásicos reinventados", image: desserts.chocolateCake },
    { name: "Recetario Postres Sin Hornear", detail: "Mezcla, refrigera y listo · 0 estrés", image: desserts.swirlBars },
    { name: "Recetario Muffins", detail: "El desayuno perfecto para llevar", image: desserts.lemonMuffins },
    { name: "Recetario Cookies", detail: "El snack fácil para cualquier hora", image: desserts.starCookies },
    { name: "Cremas y Rellenos Maestros", detail: "Combina y crea cientos de versiones", image: desserts.raspberryCake },
  ],
};

export const bonuses = [
  { number: 1, title: "Recetario para Niños", tagline: "Cero picos de azúcar", value: 47, image: desserts.homemadeOreos },
  { number: 2, title: "Snacks Saludables", tagline: "Adiós ansia de las 5 PM", value: 37, image: desserts.pistachioBars },
  { number: 3, title: "Guía Despensa Saludable", tagline: "Ahorra $ en tu supermercado", value: 27, image: lifestyle.pantry },
  { number: 4, title: "Membresía de Actualización de por Vida", tagline: "Nuevas recetas sin costo extra", value: 97, image: lifestyle.goldCard },
];

export const notificationNames = [
  "Lucía", "Valentina", "Camila", "Sofía", "Mariana", "Daniela", "Gabriela", "Carolina",
  "Andrea", "Paola", "Natalia", "Fernanda", "Alejandra", "Isabel", "Verónica", "Claudia",
  "Patricia", "Rocío", "Lorena", "Ximena", "Florencia", "Carmen", "Teresa", "Julieta",
  "Ana", "Laura", "Beatriz", "Silvia", "Mónica", "Raquel", "Pilar", "Renata",
];

export const paymentMethods = [
  { name: "Mercado Pago", slug: "mercadopago", color: "00B1EA", label: "Mercado Pago", featured: true },
  { name: "Visa", slug: "visa", color: "1A1F71" },
  { name: "Mastercard", slug: "mastercard", color: "EB001B" },
  { name: "American Express", slug: "americanexpress", color: "2E77BC" },
  { name: "PayPal", slug: "paypal", color: "003087", label: "PayPal" },
  { name: "Apple Pay", slug: "applepay", color: "000000" },
  { name: "Google Pay", slug: "googlepay", color: "4285F4" },
];
